import { render, staticRenderFns } from "./W3CHSMConfigEditor.vue?vue&type=template&id=39ea4c6a&scoped=true&"
import script from "./W3CHSMConfigEditor.vue?vue&type=script&lang=js&"
export * from "./W3CHSMConfigEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ea4c6a",
  null
  
)

export default component.exports